import { render } from "./richTtext.vue?vue&type=template&id=44e6184d&scoped=true"
import script from "./richTtext.vue?vue&type=script&lang=js"
export * from "./richTtext.vue?vue&type=script&lang=js"

import "./richTtext.vue?vue&type=style&index=0&id=44e6184d&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.2.13_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e6184d"]])

export default __exports__